import 'roboto-fontface/css/roboto/roboto-fontface.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@mdi/font/css/materialdesignicons.css'

import Vue from 'vue'

import './plugins/axios'
import './plugins/notifications'
import './plugins/ravello'
import './plugins/meta'
import './plugins/vue2-filters'
import './plugins/vueclipboard'
import './plugins/urlstatekeeper'
import './plugins/webpush'
import vuetify from './plugins/vuetify'

import App from './App.vue'
import router from './router'
import store from './store'

import './components'
import './filters'

Vue.config.productionTip = false

new Vue({
	router,
	store,
	vuetify,
	render: h => h(App),
}).$mount('#app')
